import { Company } from '@/api/search/search-schema';

export const formatAssetName = ({
  exchange,
  ticker,
  fiscal_period,
  fiscal_year,
}: Pick<Company, 'exchange' | 'ticker' | 'fiscal_period' | 'fiscal_year'>) =>
  `${exchange}-${ticker}-${fiscal_year}-${fiscal_period}`.toLowerCase();

export const getCompanyIndexByAssetName = (
  companies: Company[],
  assetName: string
) => {
  const findFn =
    assetName.split('-').length === 2
      ? (company: Company) =>
          `${company.exchange}-${company.ticker}`.toLowerCase() === assetName
      : (company: Company) => formatAssetName(company) === assetName;

  return companies.findIndex(findFn);
};
